import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgAsanPardakht = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill='#B20C0C'
      fillRule='evenodd'
      d='M9.1 19.783c-.704-.085-1.747-1.258-2.636-1.238-.85.02-.609.758-.609.758.754 1.258 1.958 1.074 3.246.48m8.629-5.407c-.472.749-2.35 1.3-2.8 2.312-.431.968.53 1.09.53 1.09 1.819-.18 2.253-1.634 2.27-3.402m-8.639-.922c1.417-.12 3.588-2.392 5.365-2.288 1.697.1 1.163 1.56 1.163 1.56-1.599 2.463-3.993 2.009-6.528.728m8.303-6.85c1.416.12 3.588 2.392 5.364 2.288 1.697-.1 1.163-1.56 1.163-1.56-1.598-2.462-3.993-2.008-6.527-.728'
      clipRule='evenodd'
    />
    <path
      fill='#F04E23'
      fillRule='evenodd'
      d='M13.343 18.041c-1.324-1-2.92-.041-3.672.767-2.274 2.442-3.823.469-3.823.469s.795 2.537 3.908 2.58c.936.012 1.76-.15 2.862-1.089.852-.727 1.476-2.158.725-2.727m4.684-9.375c-1.834.959-1.603 3.269-1.093 4.548 1.54 3.864-1.51 4.558-1.51 4.558s3.284.457 4.991-3.03c.513-1.048.771-2.063.299-3.805-.365-1.347-1.646-2.815-2.687-2.27m-17.299 1c2.72-1.908 5.844.126 7.292 1.797 4.374 5.047 7.615 1.21 7.615 1.21s-1.772 5.021-8.003 4.882c-1.874-.041-3.513-.423-5.649-2.382C.331 13.658-.817 10.75.728 9.666m8.302.727c2.72 1.907 5.845-.127 7.292-1.797 4.375-5.048 7.615-1.212 7.615-1.212s-1.772-5.02-8.003-4.881c-1.874.042-3.512.423-5.649 2.382C8.634 6.4 7.486 9.31 9.03 10.393'
      clipRule='evenodd'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgAsanPardakht)
export default ForwardRef
